export const ParamFinder = /(^|[^\\])\$/;
export const Cypher = 'cypher';
export const LabelProperty = 'labprop';
export const BooleanSuggestion = 'boolsuggestion';
export const searchPhraseSuggestionLimit = 10;
